// extracted by mini-css-extract-plugin
module.exports = {"Partners":"Partners_Partners__SUl2K","list":"Partners_list__5ARyL","item":"Partners_item__Ruuev","container":"Partners_container__kqY7n"};